import { InjectionToken } from '@angular/core';

import { VotingHistoryFacade } from './voting-history.facade';

export const VOTING_HISTORY_FACADE =
  new InjectionToken<VotingHistoryFacade>('VOTING_HISTORY_FACADE');